import { ColumnDef } from '@tanstack/react-table';
import { ScheduledUnloadingOrderReport } from 'contracts/scheduledRepports';
import { DataTableUtils, Formatter } from 'utils';
import { downloadReport } from '../utils';

type GetColumns = () => ColumnDef<ScheduledUnloadingOrderReport>[];

const dt = new DataTableUtils<ScheduledUnloadingOrderReport>();

export const getColumns: GetColumns = () => {
  return [
    dt.buildColumn({
      accessorKey: 'created_at',
      title: 'Requisitado em',
      content: (row) => Formatter.dateTime(row.created_at),
    }),
    dt.buildColumn({
      accessorKey: 'finished_at',
      title: 'Finalizado em',
      content: (row) =>
        row.finished_at ? Formatter.dateTime(row.finished_at) : '---',
    }),
    dt.buildColumn({
      accessorKey: 'scheduling_date_start',
      title: 'Data do agendamento',
      content: (row) => {
        const { scheduling_date_start, scheduling_date_end } = row;

        if (!scheduling_date_start) {
          return '---';
        }

        if (scheduling_date_start === scheduling_date_end) {
          return Formatter.date(scheduling_date_start);
        }

        const parts = [Formatter.date(scheduling_date_start)];

        if (scheduling_date_end) {
          parts.push(Formatter.date(scheduling_date_end));
        }

        return parts.join(' - ');
      },
    }),
    dt.buildStatusColumnForScheduledReports({
      onDownloadButtonClick: downloadReport,
    }),
  ];
};
